const $ = require("jquery")

		var stamenLink = '<a href="http://stamen.com">StamenDesign</a>',
			cc3Link = '<a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>',
			ccsaLink = '<a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
			osmLink = '<a href="https://openstreetmap.org">OpenStreetMap</a>',
			thunLink = '<a href="https://thunderforest.com/">Thunderforest</a>';
		var stamenUrl = 'http://{s}.tile.stamen.com/watercolor/{z}/{x}/{y}.png',
			stamentonerUrl = 'http://{s}.tile.stamen.com/toner/{z}/{x}/{y}.png',
			stamenAttrib = 'Map tiles by '+stamenLink+', under '+cc3Link+'. Data by '+osmLink+', under '+ccsaLink+'.';
		var osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			osmmonoUrl = 'https://www.toolserver.org/tiles/bw-mapnik/{z}/{x}/{y}.png'
			osmAttrib = '&copy; ' + osmLink + ' Contributors';
		var osmhumUrl = 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
			osmhumAttrib = '&copy; ' + osmLink + ' Contributors, tiles courtesy of Humanitarian OpenStreetMap Team';    
		var landUrl = 'https://{s}.tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=04ae2b40b553462d9956c36a382bc366',
			cycleUrl = 'https://{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=04ae2b40b553462d9956c36a382bc366',
			transpUrl = 'https://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=04ae2b40b553462d9956c36a382bc366',
			thunAttrib = '&copy; '+osmLink+' Contributors & '+thunLink;
		var nlscUrl = 'https://wmts.nlsc.gov.tw/wmts/EMAP01/default/EPSG:3857/{z}/{y}/{x}.jpeg',
			blankUrl = 'https://wmts.nlsc.gov.tw/wmts/EMAP02/default/EPSG:3857/{z}/{y}/{x}.jpeg',
			nlscAttrib = '&copy; 內政部,交通部',
			cgsAttrib = '&copy; 經濟部中央地質調查所 Central Geological Survey, MOEA',
			ncdrAttrib = '&copy; 國家災害防救科技中心';
		var arealUrl = 'https://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}.jpeg';
		var spotUrl = 'https://data.csrsr.ncu.edu.tw/SP/SP2016NC_3857/{z}/{x}/{y}.png',
			spotAttrib = '&copy; 中央大學太空及遙測研究中心 CSRSR Taiwan';
		var positronUrl = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
			darkmatterUrl = 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
			cartodbAttrib = '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://cartodb.com/attributions">CartoDB</a>';
		
		
		var nlscMap = L.tileLayer(nlscUrl, {attribution: nlscAttrib, maxZoom: 20, maxNativeZoom: 20}),
			blankMap = L.tileLayer(blankUrl, {maxZoom: 20, maxNativeZoom: 20}),
			stamenMap = L.tileLayer(stamenUrl, {attribution: stamenAttrib, maxZoom: 20, maxNativeZoom: 16}),
			stamentonerMap = L.tileLayer(stamentonerUrl, {attribution: stamenAttrib, maxZoom: 20, maxNativeZoom: 18}),
			osmMap = L.tileLayer(osmUrl, {attribution: osmAttrib, maxZoom: 20, maxNativeZoom: 19}),
			osmmonoMap = L.tileLayer(osmmonoUrl, {attribution: osmAttrib, maxZoom: 20, maxNativeZoom: 19}),
			landMap = L.tileLayer(landUrl, {attribution: thunAttrib, maxZoom: 20, maxNativeZoom: 18}),
			cycleMap = L.tileLayer(cycleUrl, {attribution: thunAttrib, maxZoom: 20, maxNativeZoom: 18}),
			transpMap = L.tileLayer(transpUrl, {attribution: thunAttrib, maxZoom: 20, maxNativeZoom: 18}),
			osmhumMap = L.tileLayer(osmhumUrl, {attribution: osmhumAttrib, maxZoom: 20, maxNativeZoom: 19}),
			arealMap = L.tileLayer(arealUrl, {attribution: nlscAttrib, maxZoom: 20, maxNativeZoom: 19});
			spotMap = L.tileLayer(spotUrl, {attribution: spotAttrib, maxZoom: 20, maxNativeZoom: 17});
			positronMap = L.tileLayer(positronUrl, {attribution: cartodbAttrib, maxZoom: 20, maxNativeZoom: 19});
			darkmatterMap = L.tileLayer(darkmatterUrl, {attribution: cartodbAttrib, maxZoom: 20, maxNativeZoom: 19});
		var baseLayers = {
			"(無底圖)": blankMap,
			"通用版電子地圖(灰階)": nlscMap,
			"CartoDB 正子地圖": positronMap,
			"CartoDB 暗物質地圖": darkmatterMap,
			"農林航測所航照圖": arealMap,
		//    "太遙中心 SPOT 衛星影像": spotMap,
			"OSM 開放街圖": osmMap,
			"OSM 地形圖": landMap,
			"OSM 單車路線圖": cycleMap,
			"OSM 交通路線圖": transpMap,
			"OSM 人道救援圖": osmhumMap,
		//    "OSM 灰階圖": osmmonoMap,
			//"Stamen 黑白地圖": stamentonerMap,
			//"Stamen 水彩地圖": stamenMap,
		};

		$(document).ready(function() {
			//scrollable layer control
			var ctner = document.getElementsByClassName("leaflet-control-layers")[0];
			var menulist = document.getElementsByClassName("overflow")[0];
			L.DomEvent
				.disableClickPropagation(ctner)
				.disableScrollPropagation(ctner);
			L.DomEvent
				.disableClickPropagation(menulist)
				.disableScrollPropagation(menulist);
			$('.leaflet-container').css('background-color', 'rgba(255,0,0,0.0)');
			$('.leaflet-control-layers').css('max-height', '100vh');
			$('.leaflet-control-layers').css('overflow', 'auto');
			//no frames
			$('.leaflet-control-layers').css('background', 'transparent');
			$('.leaflet-control-layers').css('border-radius', 'none');
			$('.leaflet-control-layers').css('box-shadow', 'none');
			$('.leaflet-control-layers .leaflet-control-layers-list').css('background', 'rgba(200,200,200,0.8)');
			$('.leaflet-control-layers .leaflet-control-layers-list').css('box-shadow', '0 1px 5px rgba(0,0,0,0.4)');
			$('.leaflet-control-layers .leaflet-control-layers-list').css('padding', '5px 5px 5px 5px');
			$('.leaflet-control-layers .leaflet-control-layers-list').css('font', '20px/1.5 "微軟正黑體", Arial, Helvetica, sans-serif');
			$('.leaflet-control').css('font', '20px/1.5 "微軟正黑體", Arial, Helvetica, sans-serif');
			//$('.leaflet-popup-content').css('font', '14px/1.5 "微軟正黑體", Arial, Helvetica, sans-serif');
			$('.leaflet-control-attribution').css('font', '12px/1.5 "微軟正黑體", Arial, Helvetica, sans-serif');
			//$('.leaflet-container').css('font', '20px/1.5 "微軟正黑體", Arial, Helvetica, sans-serif');
			//customized icon for the control
			$('.leaflet-control-layers-toggle').css('background-image', 'url(images/living_13.png)');
			$('.leaflet-control-layers-toggle').css('width', '60px');
			$('.leaflet-control-layers-toggle').css('height', '60px');
			$('.leaflet-control-layers-toggle').css('background-size', '100% 100%');
			$('.leaflet-control-layers-toggle').css('background-color', 'transparent');
			$('.leaflet-control-layers-toggle').css('border-color', 'transparent');
			$('.leaflet-retina .leaflet-control-layers-toggle').css('background-image', 'url(images/living_13.png)');
			$('.leaflet-retina .leaflet-control-layers-toggle').css('width', '40px');
			$('.leaflet-retina .leaflet-control-layers-toggle').css('height', '40px');
			$('.leaflet-retina .leaflet-control-layers-toggle').css('background-size', '100% 100%');
			$('.leaflet-retina .leaflet-control-layers-toggle').css('background-color', 'transparent');
			$('.leaflet-retina .leaflet-control-layers-toggle').css('border-color', 'transparent');
			$('.leaflet-pane .leaflet-popup-pane').prop('style','font-family: 微軟正黑體, "Microsoft JhengHei"; color: #553d0d; font-size: 12px');
			$('.leaflet-control-layers').prop("style","max-height: 100vh; overflow: visible; background: transparent none repeat scroll 0% 0%; box-shadow: none;");
			$('.ctrldiv').prop('style','max-height: 33vh; overflow: auto; width: 200px; font: 20px/1.5 "微軟正黑體", Arial, Helvetica, sans-serif;');
			//$('.easy-button-container').prop('style','border:1px; padding:0px;')
			$('.easy-button-button').prop('style','width:30px; height:30px; padding:0px;')
			$('.button-state').prop('style','margin:auto; border:1px; padding:0px;')
			$('.leaflet-control-layers').removeClass("leaflet-control-layers-expanded");
			//Did this following line due to mislocation of map div in FF mobile:
			//https://stackoverflow.com/questions/36246815/data-toggle-tab-does-not-download-leaflet-map
			window.dispatchEvent(new Event('resize'));
			//positronMap.addTo(map);
			//console.log(tbox);
			//if (geomtype == 'point'){
			//	$("#colselect").find('[name="cols"]').click();
			//}
			vectorGrid.bringToFront();
			//remap();

			//$('#categ1').show();
			//$('#categ2').show();
			//$('#categ3').show();
			//$('#year').show();
			//$('#county').show();
			//$('#town').show();
			//$('#wmtslist').show();
			//$('#selectloc').show();
			//$('#searchmyloc').show();
			//$('#zoom2county').show();
			//$('#dataloaded').show();
			//$('#legendtitle').show();

			////Trial run of the DBPedia query on towns
			//$.ajax({
			//	type: 'POST',
			//	url: 'dbpediacursor',
			//	data: {town_id_n:'10020010'}
			//}).done(function(resp) {
			//	console.log('鄉鎮概述：'+resp.abstract);
			//	console.log('更多相關內容，詳見<a href="'+resp.link+'">Wikipeida連結</a>');
			//	console.log('對於內容有意見或建議者，請前往<a href="'+resp.discussion+'">Wikipeida討論區</a>。');
			//});
			////Trial run of the DBPedia query on counties
			//$.ajax({
			//	type: 'POST',
			//	url: 'dbpediacounty',
			//	data: {county_id_n:'10020'}
			//}).done(function(resp) {
			//	console.log('縣市概述：'+resp.abstract);
			//	console.log('更多相關內容，詳見<a href="'+resp.link+'">Wikipeida連結</a>');
			//	console.log('對於內容有意見或建議者，請前往<a href="'+resp.discussion+'">Wikipeida討論區</a>。');
			//});
			////Trial run of spatial query for the containing polygon of a certain point
			//$.ajax({
			//	type: 'POST',
			//	url: 'getlocid',
			//	data: {"lng":121.584406,"lat":24.986193}
			//}).done(function(resp) {
			//	new Promise((resolve, reject) => {
			//		$('#county').val(resp.county_id_n).change();
			//		resolve();
			//	}).then(function(){
			//		$('#town').val(resp.town_id_n).change();
			//	})
			//});
			///////
			////Trial run for natinoal ranking of population count
			//$.ajax({
			//	type: 'POST',
			//	//url: 'nationalrank',
			//	data: {"dataset":'pop',"year":"_106", "adminscl":"_town", "column":"p_cnt","id":"63000050"}
			//}).done(function(resp) {
			//	console.log(resp);
			//});
			////Trial run for county ranking of population count
			//$.ajax({
			//	type: 'POST',
			//	//url: 'countyrank',
			//	data: {"dataset":'pop',"year":"_106", "adminscl":"_town", "column":"p_cnt","id":"63000050"}
			//}).done(function(resp) {
			//	console.log(resp);
			//});
			///////
			countynames.addTo(map);
			$('#searchmyloc').click();
		});

		var countynames = new L.GeoJSON.AJAX("includes/county.geojson",{
			pointToLayer: function (feature, latlng) {
				return new L.Marker(latlng, {
					icon: new L.DivIcon({
						className: 'leaflet-pane leaflet-popup-pane',
						iconSize: [60,20],
						iconAnchor: [30,10],
						popupAnchor: [0,0],
						html: '<a style="display:block;width:60px;text-align:center;font-family: 微軟正黑體, &quot;Microsoft JhengHei&quot;; color: rgb(85, 61, 13); font-size: 12px;">'+feature.properties.county+'<a>',
					}),
					interactive: false
				})
			},
		});
		var townnames = new L.GeoJSON.AJAX("includes/town.geojson",{
			pointToLayer: function (feature, latlng) {
				return new L.Marker(latlng, {
					icon: new L.DivIcon({
						className: 'leaflet-pane leaflet-popup-pane',
						iconSize: [60,20],
						iconAnchor: [30,10],
						popupAnchor: [0,0],
						html: '<a style="display:block;width:60px;text-align:center;font-family: 微軟正黑體, &quot;Microsoft JhengHei&quot;; color: rgb(85, 61, 13); font-size: 12px;">'+feature.properties.town+'<a>',
					}),
					interactive: false
				})
			}
		});
		var county_bbox = [];
		var town_bbox = [];
		var csel = '';
		var tsel = '';
		var categs = [];
		var cat1sel = 'nullcat1'; //the default 
		var cat2sel = 'nullcat2'; //the default 
		var cat3sel = 'nullcol'; //the default 
		var baselayer; //placeholder for the baselayer
		$.getJSON( "includes/county_bbox.json", function(ary) {
			$("#county").html('<option value="00000">縣市</option>');
			$("#town").html('<option value="00000000">鄉鎮市區</option>');
			$.each(ary, function(idx,obj) {
				$("#county").append("<option value="+obj.county_id_n+">"+obj.county+"</option>");
			});
			county_bbox = ary;
		});
		$.getJSON( "includes/town_bbox.json", function(ary) {
			town_bbox = ary;
		});
		$("#county").change(function() {
			//console.log(framehighlight);
			//if (framehighlight){
			//	clearframeHighlight();
			//}
			csel = $("#county").val();
			if (csel == '00000' && !map.hasLayer(countynames) && map.getZoom()<= 9 && colsel == 'nullcol'){
				countynames.addTo(map);
				townnames.remove(map);
			}
			//get the county bbox
			var cselobj = county_bbox.filter(function (item) {
				return item.county_id_n == csel;
			});
			if (csel && csel != '00000'){
				var cselbbox = [[cselobj[0].lat1,cselobj[0].lng1],[cselobj[0].lat2,cselobj[0].lng2]];
				if (!$("#town").val()||$("#town").val()=='00000000'){
					var zoom = map.getBoundsZoom(cselbbox);
					if (zoom <= 9){
						ccenter=[(cselobj[0].lat1+cselobj[0].lat2)/2,(cselobj[0].lng1+cselobj[0].lng2)/2];
						map.setView(ccenter,10);
					}else{
						map.fitBounds(cselbbox,{maxZoom:12})
					}
				}
			}
			var towns_csel = town_bbox.filter(function (item) {
				return item.county_id_n == csel;
			});
			$("#town").html('<option value="00000000">鄉鎮市區</option>');
			$.each(towns_csel, function(idx,obj) {
				$("#town").append("<option value="+obj.town_id_n+">"+obj.town+"</option>");
			});
			//countynames.remove(map);
			//townnames.addTo(map);

		})
		var framesel = null;
		var framevalue = null;
		var getHighlight = function (dataset,column,year,adminscl,id,cb){
			if (adminscl == '_town' && cat2selobj.minscl == 'county'){ adminscl = '_county' }
			if (geomtype != 'wmts'){
				$.ajax({
					type: 'POST',
					url: 'getdata',
					//async: false,
					data: {"dataset":dataset, "column":column, "year":year, "adminscl":adminscl, "id":id},
					success: function(p){
						cb(p);
					}
				})
			}else{
				cb(null)
			};
		}
		$("#town").change(function() {
			tsel = $("#town").val();
			if (tsel != '00000000'){
				//console.log(tsel);
				var tselobj = town_bbox.filter(function (item) {
					return item.town_id_n == tsel;
				});
				var tselbbox = [[tselobj[0].lat1,tselobj[0].lng1],[tselobj[0].lat2,tselobj[0].lng2]];
				map.fitBounds(tselbbox,{maxZoom:12});
				//reset the style to change opacity
				var adminscl = '';
				if (map.getZoom()<=9 || minscl == 'county'){
					framesel = csel;
					adminscl = "_county";
				}else{
					framesel = tsel;
					adminscl = "_town";
				};
				new Promise((resolve, reject) => {
					clearframeHighlight();
					resolve();
				}).then(function(){
					getHighlight(layerset,colsel,year,adminscl,tsel,function(p){
						highlightFrame(Number(p),vectorGrid,tsel);
						framehighlight = framesel;
						framevalue = Number(p);
					});
				})
				
			};
		})
		var allwmts = [];
		$.getJSON( "categs12", function(ary) {
			categs = ary;
			//console.log(categs);
			$("#categ1").html('<option value=""></option>').change();
			categs.forEach(function(cat,icat1){
				if (cat.status == 'online'){
					$("#categ1").append("<option value="+cat.id+">"+cat.title+"</option>")
				}
				cat.subcategs.forEach(function(cat2,icat2){
					if (cat2.geomtype=='wmts'){
						cat2.columns.forEach(function(cat3,icat3){
							allwmts.push(cat3)
						});
					}
				});
			});
		});

		var cat1selobj={};
		$("#categ1").change(function() {
			$("#categ3").html('<option value=""></option>');
			$("#year").html('<option value=0></option>');
			$("#categ2").html('<option value=""></option>');
			if (!$("#wmtslist").val()){
				$("#wmtslist").val('[]');
			}
			if (!$("#pntlayerlist").val()){
				$("#pntlayerlist").val('[]');
			}
			cat1sel = $("#categ1").val();
			if (cat1sel && cat1sel != ''){
				$("#categ2").html('<option value=""></option>');
				cat1selobj = categs.filter(function(item){return item.id == cat1sel;})[0];
				//console.log(cat1selobj);
				cat1selobj.subcategs.forEach(function(cat){
					if (cat.status == 'online'){
						$("#categ2").append("<option value="+cat.id+">"+cat.title+"</option>")
					};
				});
			}else{
				cat1sel = 'nullcat1';
				$("#categ2").val('nullcat2').change()
			}
		})

		var cat2selobj={};
		$("#categ2").change(function() {
			$("#categ3").val('');
			$("#year").val(0);
			window.scrollTo({ top: 0, behavior: 'smooth' });
			cat2sel = $("#categ2").val();
			//console.log(cat2sel);
			if (cat2sel &&　cat2sel != ''){
				$("#categ3").html('<option value=""></option>');
				//colcode = [''];
				//coltype = [''];
				//pname = [''];
				cat2selobj = cat1selobj.subcategs.filter(function(item){return item.id == cat2sel;})[0];
				//console.log(cat2selobj);
				if (cat2selobj.geomtype == 'wmts'){
					$('#collegend').hide();
					lyrcode = cat2selobj.columns.map(x => x.id);
					lyrname = cat2selobj.columns.map(x => x.title);
					lyrchk = Array(cat2selobj.columns.length).fill(0);
					updatemultisel();
					//console.log(lyrcode);
					//console.log(lyrname);
					//console.log(lyrchk);
					//$(".leaflet-bottom.leaflet-left").show();
				}
				if (cat2selobj.geomtype != 'point' && map.hasLayer(pointGrid)){
					pointGrid.remove(map);
				}
				if (cat2selobj.columns){
					cat2selobj.columns.forEach(function(cat,icat){
						//console.log(cat);
						//console.log(categs[cat1sel][cat2sel].columns[cat]);
						if (cat.status == 'online'){
							$("#categ3").append("<option value="+cat.id+">"+cat.title+"</option>")
						};
						if (icat == cat2selobj.columns.length -1 && cat2selobj.geomtype == 'wmts'){
							$("#categ3").val(cat2selobj.columns[0].id).change();
						}
					});
					if (cat2selobj.years){
						$("#year").html('<option value=0></option>');
						cat2selobj.years.forEach(function(yr,iyr){
							$("#year").append("<option value="+yr+">"+yr+"</option>")
							if (iyr == cat2selobj.years.length -1 && cat2selobj.geomtype == 'wmts'){
								$("#year").val(cat2selobj.years[0]).change();
							}
						});
					}
				}
			}else{
				cat2sel = 'nullcat2';
				cat2selobj ={"id":"nullcat2","title":"選擇縣市╱鄉鎮","status":"nullstatus",
								"table_prefix":"null",
								"geomtype":"polygon",
								"minscl":"town",
								"multiyear":false,
								"years":[106]
							};
				$("#year").html('<option value=106></option>').change();
				$("#categ3").val('nullcol').change();
			}
			//update the current zoom status
			if (cat2selobj.minscl == 'village'){
				if (map.getZoom() > 12){
					zoom0 = 2;
				} else if (map.getZoom() > 9){
					zoom0 = 1;
				} else {
					zoom0 = 0;
				}
			}
			if (cat2selobj.minscl == 'town'){
				if (map.getZoom() > 9){
					zoom0 = 1;
				} else {
					zoom0 = 0;
				}
			}
			if (cat2selobj.minscl == 'county'){
				zoom0 = 0;
			}
		})

		$("#year").change(function() {
			yr = $("#year").val();
			geomtype = cat2selobj.geomtype;
			minscl = cat2selobj.minscl;
			year = '_'+yr;
			if (geomtype == 'wmts'){
				tslayer = layerset+year;
			}else{
				layerset = 'null'
			}
			lyrchk = Array(colcode.length).fill(0);
			lyrchk = [];
			//console.log(geomtype);
			//console.log(minscl);
			//console.log(layerset);
			//console.log(year);
			//console.log(tslayer);
			//console.log(mvtpath(tslayer));
			//console.log(colcode);
			//console.log(coltype);
			//console.log(pname);
			//console.log(colsel);
			//console.log(typsel);
			//console.log(namesel);
			//console.log(cat1sel);
			//console.log(cat2sel);
			//$.ajax({
			//	type: 'POST',
			//	url: 'tsphrase',
			//	data: {geomtype:geomtype,minscl:minscl,layern:tslayer,colcode:colcode,coltype:coltype}
			//}).done(function(data) {
			//	if ($("#categ3").val() && $("#categ3").val() != ''){
			//		remap()
			//	}
			//});
			//console.log($("#categ3").val())
			if ($("#categ3").val() && $("#categ3").val() != ''){
				tsparams(cat1sel,cat2sel,colsel,year);
			}
		});
		
		var cat3selobj={};
		$("#categ3").change(function() {
			colsel = $("#categ3").val();
			console.log('categ3 changed to '+colsel);
			new Promise((resolve, reject) => {
				//if (colsel &&　colsel != '' && cat2selobj.geomtype != 'wmts'){
				if (colsel &&　colsel != ''){
					cat3selobj = cat2selobj.columns.filter(function(item){return item.id == colsel;})[0];
					typsel = cat3selobj.type;
					if ($("#legendtitle").val()) {
						namesel = $("#legendtitle").val();
					}else{
						namesel = cat3selobj.title;
					}
				}else{
					$('#collegend').hide();
					colsel = 'nullcol'
					cat3selobj = {"id":"nullcol","title":"選擇縣市╱鄉鎮","descr":"","type":"int","status":"nullstatus"};
					typsel = 'int';
					namesel = '選擇縣市╱鄉鎮'
				}
				//console.log(cat1sel,colsel);
				resolve();
			}).then(function(){
				if ($("#year").val() && $("#year").val() != 0){
					tsparams(cat1sel,cat2sel,colsel,year);
				}
			})
		})
		var wmtsMap = {};
		var currentwmtslist = []
		$("#wmtslist").change(function() {
			var currentMinZoom = 0;
			//console.log(currentwmtslist);
			//console.log($("#wmtslist").val())
			if ($("#wmtslist").val() != ''){
				wmtslist = JSON.parse($("#wmtslist").val());
			}
			//console.log(wmtslist)
			//console.log(allwmts);

			var wmtslayers = allwmts.filter(function(item){return wmtslist.indexOf(item.id) > -1;})
			//console.log(wmtslayers);
			//Make a hard copy because we're using <splice> onto <currentwmtslist>
			currentwmtslist0 = JSON.parse(JSON.stringify(currentwmtslist));
			currentwmtslist0.forEach(function(wmtsitem){
				if (wmtslist.indexOf(wmtsitem) == -1){
					if (wmtsMap[wmtsitem]){
						wmtsMap[wmtsitem].remove(map);
						currentwmtslist.splice(currentwmtslist.indexOf(wmtsitem), 1)
						delete(wmtsMap[wmtsitem]);
						//console.log(currentwmtslist);
					}
				}
			});
			wmtslist.forEach(function(wmtsitem){
				if (currentwmtslist.indexOf(wmtsitem) == -1){
					//console.log(wmtsitem)
					currentwmtslist.push(wmtsitem);
					var wmtslayer = wmtslayers.filter(function(item){return item.id == wmtsitem;})[0];
					//console.log(wmtslayer);
					if (wmtslayer){
						if (currentMinZoom < wmtslayer.minZoom) {currentMinZoom = wmtslayer.minZoom}
						if (wmtslayer.type == 'wmts'){
							wmtsMap[wmtsitem]=
								L.tileLayer(wmtslayer.url, {attribution: wmtslayer.attribution, maxZoom: wmtslayer.maxZoom, maxNativeZoom: wmtslayer.maxNativeZoom})
								.addTo(map);
						}else if (wmtslayer.type == 'wms'){
							wmtsMap[wmtsitem]=
								L.tileLayer.wms(wmtslayer.url, {layers: wmtslayer.layers, format: wmtslayer.format, transparent:'true', attribution: wmtslayer.attribution, maxZoom: wmtslayer.maxZoom, maxNativeZoom: wmtslayer.maxNativeZoom})
								.addTo(map);
						}
						wmtsMap[wmtsitem].setOpacity(0.7)
					} 
					//console.log(currentwmtslist);
					//console.log(wmtsMap);
				}
			});
			if (geomtype != 'wmts' && $('#categ1').val() && $('#categ1').val()!='nullcat1'){
				geomtype = 'wmts'
				//console.log(vectorGrid._overriddenStyles)
				tsparams('environ','hazards','drbrisflow','_106');
			}
			//remap();
			if (map.getZoom() < currentMinZoom) {
				map.setZoom(currentMinZoom)
			}
			if (framesel){
				var adminscl = '';
				if (map.getZoom()<=9 || minscl == 'county'){
					framesel = csel;
					adminscl = "_county";
				}else{
					framesel = tsel;
					adminscl = "_town";
				};
				//getHighlight(layerset,colsel,year,'_town',tsel);
				getHighlight(layerset,colsel,year,adminscl,tsel,function(p){
					//console.log(p);
					highlightFrame(Number(p),vectorGrid,framesel);
					framehighlight = framesel;
					framevalue = Number(p);
				});
				//highlightFrame(framevalue,vectorGrid,framesel);
			};
			if (map.hasLayer(townnames) && (wmtslist.indexOf("taiwan_emap") > -1 || wmtslist.indexOf("osm_transp") > -1 || wmtslist.indexOf("osm_cycle") > -1)){
				townnames.remove(map)
			};
			if (map.hasLayer(countynames) && (wmtslist.indexOf("taiwan_emap") > -1 || wmtslist.indexOf("osm_transp") > -1 || wmtslist.indexOf("osm_cycle") > -1)){
				countynames.remove(map)
			};
			if (!(wmtslist.indexOf("taiwan_emap") > -1 || wmtslist.indexOf("osm_transp") > -1 || wmtslist.indexOf("osm_cycle") > -1) && !(map.hasLayer(townnames) || map.hasLayer(countynames))){
				if (map.getZoom()<= 9){ 
					countynames.addTo(map);
				}else{
					townnames.addTo(map)
				}
			};
			if (baselayer){ baselayer.bringToBack(); }

		})

		var init_zoom = 8;
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			init_zoom = 7;
		}

		var map = L.map('map', {
			//use the NLSC Grey-Scale Map as background by default.
			//layers: [osmmonoMap],
			layers: [blankMap],
			zoom: init_zoom,
			maxZoom: 23,
			//alternative: CKS Hall, Taipei
			//center: [25.032670, 121.519174],
			//alternative: Center of Taiwan
			center: [23.65, 121],
			animate: true,
		});

		var hostname=window.location.hostname;

		//Initialize parameters for the vector tiles
		var range = [-1,1e23,1e23,1e23,1e23,1e23,1e23];
		var rangevill = [-1,1e23,1e23,1e23,1e23,1e23,1e23];
		var rangetown = [-1,1e23,1e23,1e23,1e23,1e23,1e23];
		var rangecounty = [-1,1e23,1e23,1e23,1e23,1e23,1e23];
		//var pgphrvill = '';
		//var pgphrtown = '';
		//var pgphrcounty = '';
		//var cwlayer = ''; //current working layer
		//var cwid = ''; //current working geometry id
		//var cwname = '' //current working geometry feature name
		//var ulayer = ''; //upper-scale layer frame


		///////////////////////////
		//The geometry, minimum scale of administration units, and main layer name.
		var geomtype = 'polygon';
		var minscl = 'town';
		var layerset = 'null';
		var year = '_106';
		var tslayer = layerset+year;
		mvtpath = function(tslayer){return '../ts/'+tslayer+'/{z}/{x}/{y}.mvt';};
		var colcode = ['','nullcol'];
		var coltype = ['','int'];
		var pname = ['','選擇縣市╱鄉鎮'];

		var pointGrid = {}; //place holder for pointGrid;
		var pointStyles ={}; //place holder for pointStyles;

		//var pntyear = 0;
		//var pntlayerset = '';
		//var	layernames = [];
		//var	colcodes = []
		//var	colcolors = []
		//var	zorders = []
		//var	ids = [];
		var tsparams = function(cat1sel,cat2sel,colsel,year){
			//console.log(categs);
			//console.log(cat1sel,cat2sel,colsel,year);
			//console.log(colsel);
			//console.log(geomtype);
			cat1selobj = categs.filter(function(item){return item.id == cat1sel;})[0];
			//console.log(cat1selobj);
			cat2selobj = cat1selobj.subcategs.filter(function(item){return item.id == cat2sel;})[0];
			geomtype = cat2selobj.geomtype;
			//console.log(cat2selobj);
			if (colsel != ''){
				cat3selobj = cat2selobj.columns.filter(function(item){return item.id == colsel;})[0];
			}else{
				cat3selobj = cat2selobj.columns[0];
				colsel = cat3selobj.id;
			}
			//console.log(cat3selobj);
			typsel = cat3selobj.type;
			if ($("#legendtitle").val()) {
				namesel = $("#legendtitle").val();
			}else{
				namesel = cat3selobj.title;
			}
			layerset = cat2selobj.table_prefix;
			tslayer = layerset+year;
			//The MVT path
			//var mvtpath = function(tslayer){return '../ts/'+tslayer+'/{z}/{x}/{y}.mvt';}
			
			//ToDo: re-code to make style refreshing smooth, as described in https://github.com/Leaflet/Leaflet/issues/3005
			colcode = [''];
			coltype = [''];
			pname = [''];
			var related = cat1selobj.subcategs.filter(function(item){return item.table_prefix == cat2selobj.table_prefix;});
			related.forEach(function(cat){
				cat.columns.forEach(function(element){
					colcode.push(element.id);
					coltype.push(element.type);
					pname.push(element.title);
				})
			});

			//Call the vector tile service
			//console.log(geomtype,minscl,tslayer,colcode,coltype)
			//console.log(vectorGrid._overriddenStyles);
			//console.log(framehighlight);
			if (geomtype == 'wmts'){
				//console.log(vectorGrid.options.vectorTileLayerStyles.cwlayer)
				if (!vectorGrid.options.vectorTileLayerStyles.cwlayer.color){
				//if (!$('#categ1').val()){
					//console.log('triggering remap. . .')
					$('#categ1').val('nullcat1').change();
					if (framehighlight) {
						highlightFrame(null,vectorGrid,framehighlight);
					}
				}
			}else{
				$.ajax({
					type: 'POST',
					url: 'tsphrase',
					data: {geomtype:geomtype,minscl:minscl,layern:tslayer,colcode:colcode,coltype:coltype}
				}).done(function(data) {
					if (tslayer == 'null_106'){
						vectorGrid.addTo(map);
					}else{
						remap();
					}
					//geomtype0 = geomtype;
				});
			}
			if (geomtype == 'point'){
				var pntyear = $('#year').val();
				var pntlayerset = colsel+'_'+pntyear+'_point';
				var pntlayers = [colsel];
				var colcodes = [cat3selobj.infocols];
				var coltitles = [cat3selobj.infotitles];
				var colcolors = [cat3selobj.pntcolor];
				var zorders = [2];
				var ids = ['gid'];
				if (map.getZoom() < 13) {
					map.setZoom(13)
				}
				pntlayers.forEach(function(pntlayer,ipntlyr){
					pointStyles[pntlayer]=  {
						weight: 2,
						color: colcolors[ipntlyr],
						opacity: 1.0,
						fillColor: colcolors[ipntlyr],
						fill: true,
						radius: 6,
						fillOpacity: 0.7,
						zorder:zorders[ipntlyr]
					}
				})
				var drawPointGrid = function(){
					$.ajax({
						type: 'POST',
						url: 'pntphrase',
						data: {layerset:pntlayerset,layernames:pntlayers,year:pntyear,colcodes:colcodes,ids:ids}
					}).done(function(data) {
						//remap();
					});
					pointGrid = L.vectorGrid.protobuf(mvtpath(pntlayerset), {
						//rendererFactory: L.canvas.tile,
						vectorTileLayerStyles: pointStyles,
						interactive: true,
						minZoom: 13,
						maxZoom: 23,
						getFeatureId: function(f) {
							return f.properties.gid;
						}
					})
					.on('click', function(e) {
						var color = e.layer.options.color;
						var popupContent = function(){
							var pcontent = '';
							colcodes[0].forEach(function(colcode,icol){
								if (e.layer.properties[colcode]){
									if (icol != colcodes[0].length-1){
										pcontent += coltitles[0][icol]+'：'+e.layer.properties[colcode]+'</br>';
									}else{
										pcontent += coltitles[0][icol]+'：'+e.layer.properties[colcode];
									}
								}
							})
							//return e.layer.properties[colcodes[0][0]]+'，'+e.layer.properties[colcodes[0][1]];
							return pcontent
						}
						L.popup()
							.setContent(popupContent)
							.setLatLng(e.latlng)
							.openOn(map);
					})
					.addTo(map).bringToFront();
				}
				if (map.hasLayer(pointGrid)){
					pointGrid.remove(map);
					drawPointGrid();
				}else{
					drawPointGrid();
				};

			}
		};

		var colsel = 'nullcol'; //default selection
		var typsel = 'int';
		var namesel = '選擇縣市╱鄉鎮';

		//var colors = ['8B4513', 'A0522D', 'D2691E', 'CD853F', 'F4A460', 'DEB887', 'FFDEAD', 'FFFFFF'],
		//var colors = ['CE3A1C', 'A0522D', 'CD853F', 'DEB887', 'FFDEAD', 'FDE9CB']; // in reverse-order with the range values
		var colors = ['cc3517', 'd88541', 'f7bf81', 'ffe3bb', 'fff7bd', 'fffeeb']; // in reverse-order with the range values

		//The highlighting function
		var highlightById = function(p,vgrd,id,name,latlng){
			var fopc = 1;
			//console.log($('#wmtslist').val());
			//if (JSON.parse($('#wmtslist').val()).length > 0){fopc = 0};
			var style = {
				fillColor: 
					p >= range[0] && p <= range[1] ? '#'+colors[5] :
					p > range[1] && p <= range[2] ? '#'+colors[4] :
					p > range[2] && p <= range[3] ? '#'+colors[3] :
					p > range[3] && p <= range[4] ? '#'+colors[2] :
					p > range[4] && p <= range[5] ? '#'+colors[1] :
					p > range[5] ? '#'+colors[0]: '#8e8e8e',
				fillOpacity: fopc,
				stroke: true,
				fill: true,
				color: 'orange',
				opacity: 1,
				weight: 2,
				zorder:1
			};
			vgrd.setFeatureStyle(id, style);
			var popupContent = function(){
				if (namesel == ''){
					return name;
				}else if (p){
					return name+'之'+namesel+'：'+p
				}else{
					if (map.getZoom() > 12 && minscl == 'village'){
						return '本項目無該處之村里統計資料。'
					}else if (map.getZoom() > 9 && minscl != 'county'){
						return '本項目無該處之鄉鎮統計資料。'
					}else{
						return '本項目無該處之縣市統計資料。'
					}
				}
			}
			if(cat1sel && cat1sel != 'nullcat1' && geomtype != 'wmts'){
				L.popup()
					.setContent(popupContent)
					.setLatLng(latlng)
					.openOn(map);
			}
		};
		var highlightFrame = function(p,vgrd,id){
			//console.log('highlight',highlight);
			//console.log('framehighlight',framehighlight);
			//console.log('id',id);
			//console.log($('#wmtslist').val())
			var fopc = 0.5;
			if (highlight == framehighlight && map.getZoom() <= 12){fopc = 1}
			//if (JSON.parse($('#wmtslist').val()).length > 0){fopc = 0};
			var style = {};
			//if (JSON.parse($('#wmtslist').val()).length > 0){
			if (colsel=='nullcol' || geomtype=='wmts'){
				style ={
					stroke: true,
					fill: false,
					color: 'blue',
					opacity: 1,
					weight: 2,
					zorder:1
				};
			}else{
				style = {
					fillColor: 
						p >= range[0] && p <= range[1] ? '#'+colors[5] :
						p > range[1] && p <= range[2] ? '#'+colors[4] :
						p > range[2] && p <= range[3] ? '#'+colors[3] :
						p > range[3] && p <= range[4] ? '#'+colors[2] :
						p > range[4] && p <= range[5] ? '#'+colors[1] :
						p > range[5] ? '#'+colors[0]: '#8e8e8e',
					fillOpacity: fopc,
					stroke: true,
					fill: true,
					color: '#553d0d',
					opacity: 1,
					weight: 2,
					zorder:1
				};
			}
			vgrd.setFeatureStyle(id, style);
		};
		var highlight; //variable to record the last id highlighted.
		var clearHighlight = function() {
			if (highlight) {
				vectorGrid.resetFeatureStyle(highlight);
			}
			highlight = null;
		};
		var framehighlight;
		var clearframeHighlight = function() {
			if (framehighlight) {
				vectorGrid.resetFeatureStyle(framehighlight);
			}
			framehighlight = null;
			framevalue = null;
		};

		//Set styling of upper layer (fixed, as a primer backgroud) and current working layer.
		var TaiwanStyle = function(colsel,range){
			this.ulayer ={
				stroke: true,
				fill: false,
				color: '#ab7d3c',
				opacity: 0.7,
				weight: 3,
				zorder:0
			};
			if (geomtype == 'wmts' || colsel == 'nullcol'){
				this.cwlayer ={
					stroke: true,
					fill: false,
					color: '#ab7d3c',
					opacity: 0.7,
					weight: 0.5,
					zorder:1
				};
			}else{
				this.cwlayer = function(properties, zoom) {
					var p = properties[colsel];
					var style = {
						fillColor: 
							p >= range[0] && p <= range[1] ? '#'+colors[5] :
							p > range[1] && p <= range[2] ? '#'+colors[4] :
							p > range[2] && p <= range[3] ? '#'+colors[3] :
							p > range[3] && p <= range[4] ? '#'+colors[2] :
							p > range[4] && p <= range[5] ? '#'+colors[1] :
							p > range[5] ? '#'+colors[0]: '#8e8e8e',
						fillOpacity: 0.5,
						stroke: true,
						fill: true,
						color: '#ab7d3c',
						opacity: 0.7,
						weight: 0.5,
						zorder:1
					}
					return style;
				};
			}
			return this;
		};
		var vectorGrid = L.vectorGrid.protobuf(mvtpath("null_106"), {
			rendererFactory: L.canvas.tile,
			vectorTileLayerStyles: TaiwanStyle("nullcol",[ -1, 1e+23, 1e+23, 1e+23, 1e+23, 1e+23, 1e+23 ]),
			interactive: true,
			minZoom: 5,
			maxZoom: 23,
			getFeatureId: function(f) {
				return f.properties.cwid;
			}
		})
		.on('mouseover', function(e) {
			//console.log(e.layer.properties.cwid);
			//if ((layerset == 'null' || geomtype == 'wmts') && framehighlight == null){
			if (layerset == 'null' && framehighlight == null){
				var properties = e.layer.properties;
				//two events returns with one click. make sure to popup information for the current working layer.
				if (properties.cwid){
					clearHighlight();
					if (framehighlight) {
						highlightFrame(null,vectorGrid,framehighlight);
					}
					highlight = properties.cwid;
					highlightById(0,vectorGrid,properties.cwid,properties.cwname,e.latlng)
				}
			};
		})
		.on('click', function(e) {
			//console.log(e.layer.properties.cwid);
			var properties = e.layer.properties;
			//two events returns with one click. make sure to popup information for the current working layer.
			if (properties.cwid){
				if (framehighlight) {
					vectorGrid.resetFeatureStyle(framehighlight);
				}
				framehighlight = null;
				////
				//console.log(geomtype);
				//if (layerset == 'null' || geomtype == 'wmts'){
				if (layerset == 'null' || geomtype == 'wmts'){
					//clearHighlight();
					//////clear highlight of the town (clearFrameHighlight() doesn't work here for some reason?)
					var id = properties.cwid;
					if(Number(id) < 100000){
						//$("#town").val('00000000');
						$('#county').val(id).change();
					}else{
						if(town_bbox.filter(function(item){return item.town_id_n == id;})[0].county_id_n == $('#county').val()){
							//console.log(id);
							$('#town').val(id).change();
						}else{
							new Promise((resolve, reject) => {
								$('#county').val(town_bbox.filter(function(item){return item.town_id_n == id;})[0].county_id_n).change();
								resolve();
							}).then(function(){
								$('#town').val(id).change();
							})
						};
					}
				} else {
					highlight = properties.cwid;
					//console.log(colsel);
					var p = properties[colsel];
					//reset the style to change opacity
					highlightById(p,vectorGrid,properties.cwid,properties.cwname,e.latlng)
				};
				
			}
		})


		map.on('popupclose', function(){
			if (layerset != 'null' && geomtype != 'wmts'){
				clearHighlight()
				//console.log(framesel)
				if (framesel){
					var adminscl = '';
					if (map.getZoom()<=9 || minscl == 'county'){
						framesel = csel;
						adminscl = "_county";
					}else{
						framesel = tsel;
						adminscl = "_town";
					};
					getHighlight(layerset,colsel,year,adminscl,tsel,function(p){
						//console.log(p);
						highlightFrame(Number(p),vectorGrid,framesel);
						framehighlight = framesel;
						framevalue = Number(p);
					});
				}

			}
		});

		//Function to run synchronous tasks
		function runSerial(tasks) {
			var result = Promise.resolve();
			tasks.forEach(task => {
				result = result.then(() => task());
			});
			return result;
		}
		showlegend = () => {
			$('#collegend').show();
			var lgndcontent;
			let tasks = [
				() => {
					lgndcontent = $('#collegend').html();
				},
				() => {
					$('#minlgnd').click( () => {
						$('#collegend').html('<button type="button" title="恢復圖例檢視" id="lgndicon" style="border-style: solid; border: 0px; padding: 0px; width: 23px; height: 23px;"><img src="images/legends.png" width="23px" height="23px" style="vertical-align:unset;"></button>');
						$('#lgndicon').click( () => {
							$('#collegend').html(lgndcontent);
							runSerial(tasks);
						});
					})
				}
			];
			runSerial(tasks);
		}

		//The control
		var ctrlon = 0;
		var ctrl = L.control({position: 'bottomleft'});

		var restylelegend = function (range){
			//console.log(range)
			//var collegend = document.getElementsByClassName('collegend')[0];
			
			//if (framehighlight) {
			//	vectorGrid.resetFeatureStyle(framehighlight);
			//}
			//framehighlight = null;
			async function drawArea(ozooming){
				//console.log(ozooming);
				//if (!ozooming){
				//	//console.log(range);
					//console.log('jumpzoom.range: '+jumpzoom.range)
				//	//take range straight from jumpzoom.range if <zoom2county> or <zoom2town>
				//	if (jumpzoom.range){
				//		range = jumpzoom.range;
				//		vectorGrid.resetFeatureStyle(TaiwanStyle(colsel,range));
				//	}else{
				//		vectorGrid.resetFeatureStyle(TaiwanStyle(colsel,range));
				//	}
				//	//console.log(range)
				//	return range
				//}else{
					//console.log(range);
					vectorGrid.resetFeatureStyle(TaiwanStyle(colsel,range));
					//console.log(range)
					return range
				//}
			}
			async function rangeLegend(range){
				//console.log(range);
				var rangetxt = '';
				if (typsel == 'real') {
					//console.log(range);
					rangetxt = range.map(x=>Number.parseFloat(x).toFixed(2).toString());
					//console.log(rangetxt)
					return rangetxt
				}else{
					//console.log(range);
					rangetxt = range.map(x=>x.toString());
					//console.log(rangetxt)
					return rangetxt
				}
			}
			async function drawLegend(rangetxt){
				//console.log(rangetxt);
				var labels = ['>'+rangetxt[rangetxt.length-1]];
				for (var i = rangetxt.length-1; i > 0; i--){
					labels.push(rangetxt[i]+'~'+rangetxt[i-1]);
				};
				if (namesel != ''){
					var legendhtm ='<button type="button" title="圖例按鈕化" id="minlgnd" style="border-style: solid; border: 0px; padding: 0px; width: 23px; height: 23px;"><img src="images/arrow_contract.png" width="23px" height="23px" style="vertical-align: unset;"></button>';
					legendhtm += namesel+':</br>'
					// loop through intervals and generate a label with a colored square for each interval
					for (var i = 0; i < colors.length; i++) {
						//console.log(colors[i]);
						legendhtm +=
							'<i style="background:#' + colors[i] + '"></i> ' + labels[i] + '<br>';
					}
					$('#collegend').html(legendhtm);
				}else{
					$('#collegend').html('');
				}
			}
			drawArea(ozooming)
			.then(range => {return rangeLegend(range)})
			.then(rangetxt => {drawLegend(rangetxt)})
			.then(()=>{if (range[1] != 1e23) showlegend();})
		}

		var zoom0 = 0;
		var jumpzoom={};

		//administration level when doing assigned zooming.
		//jumpzoom.range will be assigned if applied.
		jumpzoom.admin = 'none';

		//status for "ordinary zooming"
		var ozooming = true;

		map.on('zoomstart', function() {
			clearframeHighlight();
			console.log('zoomstart, jumpzoom: '+jumpzoom.admin)
			if (jumpzoom.admin == 'none'){
				ozooming = true
			}else{
				ozooming = false
			}
		});
		map.on('zoomend', function(){
			//console.log(zoom0);
			//console.log(minscl);
			console.log('zoomed, jumpzoom: '+jumpzoom.admin);
			if (ozooming){
				console.log('. . . by ordinary zooming')
				if (minscl == 'village' || minscl == 'town'){
					if (zoom0 == 0 && map.getZoom()>9){
						clearHighlight();
						range = rangetown;
						console.log('zoomed from county to town')
						restylelegend(range);
						zoom0 = 1;
						if (map.hasLayer(countynames)){
							townnames.addTo(map);
							countynames.remove(map);
						};
					}
					if (minscl == 'village'){
						if (zoom0 == 1 && map.getZoom()>12){
							range = rangevill;
							console.log('zoomed from town to vill')
							restylelegend(range);
							zoom0 = 2;
						}
						if (zoom0 == 2 && map.getZoom()<= 12){
							//console.log(rangetown);
							console.log('zoomed from vill to town')
							range = rangetown;
							restylelegend(range);
							zoom0 = 1;
						}
					}
					if ((zoom0 == 1 && map.getZoom()<= 9)){
						//console.log($("town").val());
						range = rangecounty;
						console.log('zoomed from town to county')
						restylelegend(range);
						zoom0 = 0;
					}
				}
				if (map.getZoom() <= 9 && map.hasLayer(townnames)){
						countynames.addTo(map);
						townnames.remove(map);
				}
				if (map.getZoom() <= 9){
					range = rangecounty
				}else if(map.getZoom()<= 12){
					range = rangetown
				}else{
					range = rangevill
				}
				console.log('      current range: '+range)
				ozooming = false;
				map.closePopup();
			}else{
				console.log('. . . by assigned zooming')
				if (map.getZoom() <= 9 && map.hasLayer(townnames)){
						countynames.addTo(map);
						townnames.remove(map);
				}
				if (jumpzoom.admin == 'county'){
					console.log('zoomed to county, assigned range: '+rangecounty);
					//if (range[1] != 1e23) showlegend();
					console.log('zoomed to as county, range: '+jumpzoom.range)
					//hand back zooming permission to user as ordinary zooming
					zoom0 = 0;
				}
				
				if (jumpzoom.admin == 'town'){
					console.log('zoomed to town, assigned range: '+rangetown);
					//if (range[1] != 1e23) showlegend();
					console.log('zoomed to as town, range: '+jumpzoom.range)
					//hand back zooming permission to user as ordinary zooming
					zoom0 = 1;
				}
				jumpzoom.admin = 'none';
				map.closePopup();
				
			}
		});

		var redrawIcon = new L.easyButton({
			id: 'redraw',  // an id for the generated button
			position: 'topleft',      // inherited from L.Control -- the corner it goes in
			states:[{                 // specify different icons and responses for your button
				onClick: function(btn, map){
					if (geomtype == 'polygon'){
						vectorGrid.redraw(TaiwanStyle);
					}else{
						if (map.getZoom() >12) {
							vectorGrid.redraw(TaiwanStyle);
							if (geomtype == 'point'){
								pointGrid.redraw(pointStyles);
							}
						}else{
							vectorGrid.redraw(TaiwanStyle);
						}
					}
				},
				title: '地圖重繪',
				icon: '<img src="images/reload.png" width="35px" height= "35px"/>'
			}]
		});
		redrawIcon.addTo(map);
		// Functions for showing and hiding the control
		function stctrl(){
			if (ctrlon!=1){
				//toolIcon.remove(map);
				$('#button-image').parent().hide();
				//ctrl.addTo(map);
				$('.ctrldiv').show();
				ctrlon = 1;
			}
		}
		//console.log($('#redraw'));
		function rmctrl(){
			if (ctrlon!=0){
				$('.ctrldiv').hide();
				ctrlon = 0;
				$('#button-image').parent().show();				
				//console.log(toolIcon);
			}
		}
		// An iconTool using EasyButton.js
		var toolIcon = new L.easyButton({
			id: 'button-image',  // an id for the generated button
			position: 'bottomleft',      // inherited from L.Control -- the corner it goes in
			states:[{                 // specify different icons and responses for your button
				onClick: function(btn, map){
					stctrl();
				},
				title: '展開選單',
				icon: '<img class="button-image" src="images/menu.png" width="26px" height= "26px"/>'
			}]
		});
		
		toolIcon.addTo(map);
		$('#button-image').parent().hide();

		var lyrcode = [];
		var lyrname = [];
		var lyrchk = [];

		var updatemultisel = function(){
			//console.log(lyrcode);
			//console.log(cat2selobj);
			function toggle(req) {
				var checkboxes = document.getElementsByName('cols');
				//console.log(checkboxes);
				for (let checkbox of checkboxes) {
					checkbox.checked = req.checked;
					if (checkbox.checked){
						lyrchk[checkbox.value]=1;
					}else{
						lyrchk[checkbox.value]=0;
					}
				}
			}
			var updatelist = function() {
				var seltd = [];
				lyrchk.forEach(function(sel,isel){
					if (sel == 1){
						seltd.push(lyrcode[isel]);
					}
				})
				$("#wmtslist").val(JSON.stringify(seltd)).change();
			}
			var multiseltbl =
				'<table cellpadding="0px" cellspacing="0px">'+
					//  The select
					'<td id="colselect" name="updatelist" >';
					//'<tr id="colselect" name="updatelist" >';
			multiseltbl +=
							'<input type="checkbox" name="toggleall"/><b>全選/取消全選</b><br/>';
			for (var i = 0; i < lyrcode.length; i++) {
				multiseltbl +=
							'<input type="checkbox" name="cols" id='+lyrcode[i]+' value='+i+'>'+lyrname[i]+'</br>'
							//'<td><input type="checkbox" name="cols" id='+lyrcode[i]+' value='+i+'>'+lyrname[i]+'</input></td>'
			};
			multiseltbl+=
					'</td>'+
					//'</tr>'+
				'</table>';

			var multiselctrl =
				'<button type="button", title="選單按鈕化", id="rmctrl", style="border-style: solid; border: 0px; padding: 0px; width: 23px; height: 23px; vertical-align:unset;"><img src="images/arrow_contract.png" width="24px" height= "24px"></button></br>'+
				'請選擇小類:</br>'+
				multiseltbl;

			div.innerHTML = multiselctrl;

			$('.ctrldiv').find('#rmctrl').click(function() {
				rmctrl();
			});
			$("#colselect").find('[name="cols"]').click(function(box){
				if (box.target.checked){
					lyrchk[box.target.value]=1;
				}else{
					lyrchk[box.target.value]=0;
				}
			})
			$("#colselect").find('[name="toggleall"]').click(function(boxes){
				toggle(boxes.target);
			})
			$("#colselect").click(function(){
				updatelist();
			})

		}

		var div = L.DomUtil.create('div', 'info legend overflow ctrldiv');
		// To avoid disabled touchscreen input/click, add the following line
		L.DomEvent.disableClickPropagation(div);

		ctrl.onAdd = function (map) {
			//ctrldiv.setAttribute('max-height', '100vh');
			//$("div .ctrldiv").prop("style","max-height: 100vh; overflow: visible; background: transparent none repeat scroll 0% 0%; box-shadow: none;");
			ctrlon = 1;
			return div;
		};

		ctrl.addTo(map);
		$(".leaflet-bottom.leaflet-left").hide();

		var pgrange = function (dataset,column,year,adminscl,cb){
			if (dataset == 'null' || geomtype == 'wmts'){
				cb([-1,1e23,1e23,1e23,1e23,1e23,1e23]);
			}else{
				//console.log(dataset);
				//console.log(column);
				//console.log(year);
				//console.log(adminscl);
				//console.log($("#county").val())
				//console.log($("#town").val())
				async function regstats(){
					$.ajax({
						type: 'POST',
						url: 'regionalstats',
						//data: {phrase: pgph}
						data: {"dataset":dataset, "column":column, "year":year, "adminscl":adminscl},
						success: function(res){
							//console.log(res);
							if (res.name != 'error'){
								cb(JSON.parse('['+res.percentiles+']'));
							}
						},
						fail: function(err){
							console.log(err)
						}
					})
				}
				regstats().then( ()=>{
					showlegend();
				})
			}
		}
		var redrawrange = function(rng){
			restylelegend(rng);
			//console.log(geomtype);
			//console.log(framehighlight);
			//console.log(vectorGrid._overriddenStyles);
			//console.log(map.getZoom());
			if(geomtype == 'polygon' ||!(framehighlight && vectorGrid._overriddenStyles[framehighlight].color=='blue')){
				console.log('redrawing map using range: '+rng);
				vectorGrid.setUrl(mvtpath(tslayer),true);
				vectorGrid.redraw(TaiwanStyle(colsel,rng));
				if (map.getZoom()>9){
					if (minscl != 'county' && map.hasLayer(countynames)){
						townnames.addTo(map);
						countynames.remove(map);
					} else if (minscl == 'county' && map.hasLayer(townnames)){
						countynames.addTo(map);
						townnames.remove(map);
						//$("#town").val("00000000");
					}
				}
				if (minscl=='county' && map.getZoom() <= 9 && map.hasLayer(townnames)){
					countynames.addTo(map);
					townnames.remove(map);
					//$("#town").val("00000000");
				}

			}
		}
		var remap = function(){
			//console.log(layerset);
			//console.log(colsel);
			//console.log(minscl);
			//console.log(year);
			if ((geomtype == 'polygon' || geomtype == 'point' || geomtype == 'wmts') && (minscl == 'village' || minscl == 'town')){
				if (minscl == 'village'){
					 pgrange(layerset,colsel,year,'_village',function(rng){rangevill = rng});
				}
				//console.log(layerset);
				//console.log(colsel);
				//console.log(minscl);
				//console.log(year);
				pgrange(layerset,colsel,year,'_town',function(rng){rangetown = rng});
				//console.log(pgrange('null','nullcol','_106','_town'));
			}

			pgrange(layerset,colsel,year,'_county',function(rng){rangecounty = rng});

			//console.log(rangevill);
			//console.log(rangetown);
			//console.log(rangecounty);

			//render the map according to current spatial scale
			if (geomtype == 'polygon' || geomtype == 'wmts'){
				//console.log(map.getZoom());
				console.log('redrawing map, current zoom: '+map.getZoom())
				console.log('jumpzoom.admin: '+jumpzoom.admin)
				
				var currentzoom = map.getZoom();
				
				if (jumpzoom.admin == 'county') currentzoom = init_zoom;
				if (jumpzoom.admin == 'town') currentzoom = 12;

				if (currentzoom >12) {
					if (minscl == 'village'){
						pgrange(layerset,colsel,year,'_village',function(rng){redrawrange(rng);range=rng;});
					}else if (minscl == 'town'){
						pgrange(layerset,colsel,year,'_town',function(rng){redrawrange(rng);range=rng;});
					}else{
						pgrange(layerset,colsel,year,'_county',function(rng){redrawrange(rng);range=rng;});
					}
				}else if (currentzoom >9) {
					if (minscl == 'village' || minscl == 'town'){
						pgrange(layerset,colsel,year,'_town',function(rng){redrawrange(rng);range=rng;});
					}else{
						pgrange(layerset,colsel,year,'_county',function(rng){redrawrange(rng);range=rng;});
					}
				}else{
					pgrange(layerset,colsel,year,'_county',function(rng){redrawrange(rng);range=rng;});
				}

			}else{
				// geomtype == 'point'
				if (map.getZoom() >12) {
					pgrange(layerset,colsel,year,'_town',function(rng){redrawrange(rng);range=rng});
					vectorGrid.redraw(TaiwanStyle(colsel,range));
					pointGrid.redraw(pointStyles);
				}else if (map.getZoom() >9) {
					pgrange(layerset,colsel,year,'_town',function(rng){redrawrange(rng);range=rng;});
					vectorGrid.redraw(TaiwanStyle(colsel,range));
				}else{
					pgrange(layerset,colsel,year,'_county',function(rng){redrawrange(rng);range=rng;});
					vectorGrid.redraw(TaiwanStyle(colsel,range));
				}
			}
			map.closePopup();
			vectorGrid.on('load', function (event) {
				//console.log(framesel)
				if (framesel){
					//clearHighlight();
					//map.closePopup();
					var adminscl = '';
					//console.log(map.getZoom());
					//console.log(csel);
					//console.log(tsel);
					if (map.getZoom()<=9 || minscl == 'county'){
						framesel = csel;
						adminscl = "_county";
					}else{
						framesel = tsel;
						adminscl = "_town";
					};
					//console.log(layerset);
					//console.log(colsel);
					//console.log(year);
					//console.log(adminscl);
					//console.log(framesel);
					
					//Intended to used <tsel> instead of <framesel> because </getdata> API takes care of the upsclaing.
					getHighlight(layerset,colsel,year,adminscl,tsel,function(p){
						//console.log(p);
						clearHighlight();
						highlightFrame(Number(p),vectorGrid,framesel);
						framehighlight = framesel;
						framevalue = Number(p);
					});
					//highlightFrame(framevalue,vectorGrid,framesel);
				}
			});
			vectorGrid.on('click', function (event) {
				if (framesel){
					var adminscl = '';
					if (map.getZoom()<=9 || minscl == 'county'){
						framesel = csel;
						adminscl = "_county";
					}else{
						framesel = tsel;
						adminscl = "_town";
					};
					getHighlight(layerset,colsel,year,adminscl,tsel,function(p){
						//console.log(p);
						//console.log(framesel)
						highlightFrame(Number(p),vectorGrid,framesel);
						framehighlight = framesel;
						framevalue = Number(p);
					});
				}
			});	
		}
		
		//The legend
		//var colors = ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
		//var colors = ['a6cee3', '1f78b4', 'b2df8a', '33a02c','fdbf6f', 'ff7f00', 'fb9a99', 'e31a1c', 'ffeda0'],
		//var colors = ['FFDEAD', 'DEB887', 'F4A460', 'CD853F', 'D2691E', 'A0522D', '8B4513', 'FFE4E1'],
		var pi = Math.PI;
		
		var legend = L.control({position: 'bottomright'});
		//Map legend
		legend.onAdd = function (map) {
		
			var legenddiv = L.DomUtil.create('div', 'info legend'),
				labels = ['','','','','','','',''];
			legenddiv.innerHTML = ''
			legenddiv.setAttribute('id','collegend');
			return legenddiv;
		};
		legend.addTo(map);
		$('#collegend').hide();

		function togglelayercontrol() {
			$('.leaflet-control-layers').removeClass("leaflet-control-layers-expanded");
		}
		//layercontrol = L.control.layers(baseLayers,overlayMaps,{collapsed:true}).addTo(map);
		layercontrol = L.control.layers(baseLayers,[],{collapsed:true}).addTo(map);
		$('<div style="text-align:left;">請選擇底圖：<button type="button", title="選單按鈕化", id="togglelayercontrol", style="float:right; border-style: solid; border: 0px; padding: 0px; width: 23px; height: 23px;"><img src="images/arrow_contract.png" width="24px" height= "24px" style="vertical-align:unset;"></button></br>').prependTo("form.leaflet-control-layers-list" )

		var searchmyloc = function (){
			map.locate({setView: false});
			map.on('locationfound', function(e){
				$.ajax({
					type: 'POST',
					url: 'getlocid',
					data: {"lng":e.longitude,"lat":e.latitude}
					//data: {"lng":121.286360,"lat":25.252106}, 
				}).done(function(resp) {
					new Promise((resolve, reject) => {
						$('#county').val(resp.county_id_n).change();
						resolve();
					}).then(function(){
						$('#town').val(resp.town_id_n).change();
					})
				});
			});
			map.on('locationerror', function(e){
				console.log("無法找到您的精確位置。");
			});
		}
		
		$('#searchmyloc').click(function() {
			searchmyloc();
		});
		$('#togglelayercontrol').click(function() {
			togglelayercontrol();
		});
		$('#selectloc').click(function() {
			//framehighlight = null;
			if (framehighlight) {
				vectorGrid.resetFeatureStyle(framehighlight);
			}
			framehighlight = null;
			framevalue = null;
			framesel = null;
			$('#wmtslist').val('[]').change();
			$('#categ1').val('nullcat1').change();
			if (map.hasLayer(pointGrid)) {
				pointGrid.remove(map);
			}
			//console.log(layerset);
		});

		
		$('#zoom2county').on( "click", function(){
			//console.log(cat2selobj)
			//console.log(cat3selobj)
			jumpzoom.admin = 'county';
			csel = $("#county").val();
			var cselobj = county_bbox.filter(function (item) {
				return item.county_id_n == csel;
			});
			var cselbbox = [[cselobj[0].lat1,cselobj[0].lng1],[cselobj[0].lat2,cselobj[0].lng2]];
			ccenter=[(cselobj[0].lat1+cselobj[0].lat2)/2,(cselobj[0].lng1+cselobj[0].lng2)/2];
			//console.log(ccenter)
			//console.log(init_zoom)
			
			//console.log(layerset,colsel,year)
			layerset = cat2selobj.table_prefix;
			colsel = cat3selobj.id;
			console.log('assigned zooming initiated, layer/colsel/year: '+layerset,colsel,year)
			ozooming = false;
			pgrange(layerset,colsel,year,'_county',function(rng){
				//console.log(rng);
				range=rng;
				rangecounty=rng;
				//jumpzoom.range=rng;
				map.setView(ccenter,8);
				zoom0=0;
				//return to ordinary zooming
				jumpzoom.admin = 'none';
				ozooming = true;

			});
		})
		$('#zoom2town').on( "click", function(){
			//console.log(cat2selobj)
			//console.log(cat3selobj)
			jumpzoom.admin = 'town';
			tsel = $("#town").val();
			//console.log(tsel);
			//console.log($("#town").val());
			var tselobj = town_bbox.filter(function (item) {
				return item.town_id_n == tsel;
			});
			var tselbbox = [[tselobj[0].lat1,tselobj[0].lng1],[tselobj[0].lat2,tselobj[0].lng2]];
			//console.log(zoom0);
			
			//console.log(layerset,colsel,year)
			layerset = cat2selobj.table_prefix;
			colsel = cat3selobj.id;
			console.log('assigned zooming initiated, layer/colsel/year: '+layerset,colsel,year)
			ozooming = false;
			pgrange(layerset,colsel,year,'_town',function(rng){
				//console.log(rng);
				range=rng;
				rangetown=rng;
				//jumpzoom.range=rng;
				map.fitBounds(tselbbox,{maxZoom:12});
				zoom0=1;
				//return to ordinary zooming
				jumpzoom.admin = 'none';
				ozooming = true;

			});
		})

		map.on('baselayerchange', function(e) {
			if (map.hasLayer(townnames) && !map.hasLayer(blankMap)){
				townnames.remove(map)
			};
			if (map.hasLayer(countynames) && !map.hasLayer(blankMap)){
				countynames.remove(map)
			};
			if (map.hasLayer(blankMap) && !(map.hasLayer(townnames) || map.hasLayer(countynames))){
				if (map.getZoom()<= 9){ 
					countynames.addTo(map);
				}else{
					townnames.addTo(map)
				}
			};
			if (map.hasLayer(vectorGrid)) {
				vectorGrid.bringToFront();
				//remap();
			};
			baselayer = e.layer; //save this one for #wmtslist change.
			e.layer.bringToBack();

			if (geomtype == 'point'){
				if (map.hasLayer(pointGrid)) {
					pointGrid.bringToFront();
				}
			}
		});
	